import { fetchHelper } from '../../../api/api'
import { getErrorMessage } from '../../../util/functions'
import { userActionsActions } from './userActionsSlice'

export const deleteBeneficiary = email => async dispatch => {
    dispatch(userActionsActions.deleteUserRequest())
    try {
        await fetchHelper.delete(`Beneficiary/${email}`)
        dispatch(userActionsActions.deleteUserRequestSuccess())
    } catch (e) {
        dispatch(userActionsActions.deleteUserRequestError(getErrorMessage(e)))
    }
}

export const deactivateBeneficiary = email => async dispatch => {
    dispatch(userActionsActions.deactivateUserRequest())
    try {
        await fetchHelper.put(`Beneficiary/Deactivate/${email}`)
        dispatch(userActionsActions.deactivateUserRequestSuccess())
    } catch (e) {
        dispatch(
            userActionsActions.deactivateUserRequestError(getErrorMessage(e))
        )
    }
}

export const activateBeneficiary = email => async dispatch => {
    dispatch(userActionsActions.activateUserRequest())
    try {
        await fetchHelper.put(`Beneficiary/Activate/${email}`)
        dispatch(userActionsActions.activateUserRequestSuccess())
    } catch (e) {
        dispatch(
            userActionsActions.activateUserRequestError(getErrorMessage(e))
        )
    }
}
